/**
 * Multi-select chip group. Renders a row of pill-shaped toggle chips.
 * - `value`: current selected array
 * - `onChange`: (newArray) => void
 * - `options`: string[]
 *
 * Used for age & gender category selection on Create/Edit Tournament.
 */
const ChipMultiSelect = ({ value = [], onChange, options, testIdPrefix = 'chip' }) => {
  const set = new Set(value);
  const toggle = (opt) => {
    if (set.has(opt)) onChange(value.filter((v) => v !== opt));
    else onChange([...value, opt]);
  };
  return (
    <div className="flex flex-wrap gap-2" data-testid={`${testIdPrefix}-group`}>
      {options.map((opt) => {
        const active = set.has(opt);
        return (
          <button
            type="button"
            key={opt}
            onClick={() => toggle(opt)}
            className={`px-3.5 py-1.5 rounded-full text-xs font-semibold border transition-all ${
              active
                ? 'bg-gray-900 text-white border-gray-900'
                : 'bg-white text-gray-700 border-gray-200 hover:border-gray-400'
            }`}
            data-testid={`${testIdPrefix}-${opt}`}
            aria-pressed={active}
          >
            {opt}
          </button>
        );
      })}
    </div>
  );
};

export default ChipMultiSelect;
